import { makeAutoObservable, runInAction } from 'mobx'
import { SurveysApi } from 'entities/Surveys'
import type {
  IResponseEventContactSurveyExecutionCreated,
  IResponseSurveyExecution,
} from 'entities/Surveys/api/types'
import type { ContactsDetailsStore } from 'widgets/ContactsDetails'

export class ContactsSurveysStore {
  private _loading = false
  private _hasSurveys: boolean | null = null
  private _executions: IResponseSurveyExecution[] = []
  private _requestId = 0

  constructor(private _contactsDetailsStore: ContactsDetailsStore) {
    makeAutoObservable(this)
  }

  get contactId() {
    return this._contactsDetailsStore.contactId
  }

  get contact() {
    return this._contactsDetailsStore.contact
  }

  get loading() {
    return this._loading
  }

  get hasNoSurveys() {
    return this._hasSurveys !== true
  }

  get executions() {
    return this._executions
  }

  addCreatedExecution = ({
    contact_id,
    ...execution
  }: IResponseEventContactSurveyExecutionCreated) => {
    if (contact_id !== this.contactId) return

    this._hasSurveys = true
    this._executions = [execution, ...this._executions]
  }

  load = async () => {
    const contactId = this.contactId
    const requestId = ++this._requestId

    if (!contactId || contactId <= 0) {
      runInAction(() => {
        this._loading = false
        this._hasSurveys = null
        this._executions = []
      })

      return
    }

    runInAction(() => {
      this._loading = true
    })

    try {
      const { data } = await SurveysApi.getContactSurveyExecutions(contactId)
      if (requestId !== this._requestId) return

      runInAction(() => {
        this._hasSurveys = data.data.length > 0
        this._executions = data.data
      })
    } catch (e) {
      console.error(e)

      if (requestId === this._requestId) {
        runInAction(() => {
          this._hasSurveys = false
          this._executions = []
        })
      }
    } finally {
      if (requestId === this._requestId) {
        runInAction(() => {
          this._loading = false
        })
      }
    }
  }
}
